export enum TagType {
	Wristband,
	BikeTag,
}
